import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 4F0EF72A-F2A8-4BFA-9E6F-279E159FC888
 * name wall-sconce-flat
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wall-sconce-flat.svg
 * tags
 * - Home Automation 
 */
export const WallSconceFlatIcon = createSvgIcon(<><path d="M5,5V11H19V5H5M5.27,13.32L3.5,15.09L4.91,16.5L6.68,14.73L5.27,13.32M18.73,13.32L17.32,14.73L19.09,16.5L20.5,15.09L18.73,13.32M11,16V19H13V16H11Z" /></>, 'WallSconceFlatIcon');
export default WallSconceFlatIcon